export class Student {
    name: string;
    career: string = '';
    message: string;
    image: any;
    frame: string = 'instagram'; //Definición por defecto
    assistantId: any = '';
    terms: any = '';
}
